export const REASON = {
  INSUFFICIENT_CANDIDATE_LEVEL: 'INSUFFICIENT_CANDIDATE_LEVEL',
  INSUFFICIENT_RECRUITER_COMPANY_LEVEL: 'INSUFFICIENT_RECRUITER_COMPANY_LEVEL',
};

export default REASON;
